// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cn-2";
export var aiChatCartContainerExit = "_cn-4";
export var aiChatContainerLarge = "_cn-0";
export var aiChatContainerSmall = "_cn-1";
export var aiChatIcon = "_cn-6";
export var slideInFromRight = "_cn-3";
export var slideOutToRight = "_cn-5";